module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-2"
  }, [_c('v-row', [_c('v-col', [_c('div', {
    staticClass: "d-flex"
  }, [(_vm.buttonShow('create')) ? _c('v-btn', {
    staticClass: "secondary",
    on: {
      "click": function($event) {
        _vm.createClientDialog = true
      }
    }
  }, [_vm._v("\n          Create new\n        ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2 pt-2 secondary--text",
    attrs: {
      "color": "secondary",
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.paginate(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat secondary--text"
  })]), _vm._v(" "), _c('v-text-field', {
    staticClass: "pl-3",
    staticStyle: {
      "max-width": "350px"
    },
    attrs: {
      "append-icon": "search",
      "label": "Search an Existing Client",
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "dense": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-card-title', {
    staticClass: "pl-0 pr-0"
  }, [(_vm.selectedClients) ? _c('v-btn', {
    attrs: {
      "small": "",
      "color": "warning",
      "disabled": !_vm.selectedClients || _vm.selectedClients.length === 0
    },
    on: {
      "click": function($event) {
        return _vm.openClientGroupModal()
      }
    }
  }, [_vm._v("Add to Group (" + _vm._s(_vm.selectedClients.length) + ")")]) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "client-nested-table client-root-table elevation-1",
    attrs: {
      "striped": "",
      "bordered": "",
      "hover": "",
      "responsive": "",
      "headers": _vm.fields,
      "items": _vm.items,
      "search": _vm.filter,
      "show-select": "",
      "show-expand": "",
      "expanded": _vm.expanded,
      "item-key": "id",
      "single-select": false
    },
    on: {
      "update:expanded": function($event) {
        _vm.expanded = $event
      },
      "toggle-select-all": _vm.selectAllClients
    },
    scopedSlots: _vm._u([{
      key: "item.data-table-expand",
      fn: function(ref) {
        var item = ref.item;
        var expand = ref.expand;
        var isExpanded = ref.isExpanded;

        return [_c('span', [(isExpanded) ? _c('v-icon', {
          on: {
            "click": function($event) {
              return expand(false)
            }
          }
        }, [_vm._v("mdi-chevron-up")]) : _c('v-icon', {
          on: {
            "click": function($event) {
              return expand(true)
            }
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }, {
      key: "item.data-table-select",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.isGroup) ? _c('v-checkbox', {
          attrs: {
            "label": "",
            "value": item,
            "color": "grey darken-2"
          },
          model: {
            value: (_vm.selectedClients),
            callback: function($$v) {
              _vm.selectedClients = $$v
            },
            expression: "selectedClients"
          }
        }) : _c('v-icon', [_vm._v("mdi-domain")])]
      }
    }, {
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [(item.isGroup && item.groupEdit) ? _c('div', [_c('v-text-field', _vm._g({
          staticClass: "input-field mt-3",
          attrs: {
            "dense": "",
            "outlined": "",
            "placeholder": "Campaign Name"
          },
          model: {
            value: (item.name),
            callback: function($$v) {
              _vm.$set(item, "name", $$v)
            },
            expression: "item.name"
          }
        }, _vm.on))], 1) : _c('div', {
          staticClass: "item-edit"
        }, [_c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.name))])])]
      }
    }, {
      key: "item.IO",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.IO))])])]
      }
    }, {
      key: "item.dealCode",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.dealCode))])])]
      }
    }, {
      key: "item.budget",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [(item.budget) ? _c('td', {
          staticClass: "text-center"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.budget)))]) : _c('td', {
          staticClass: "text-center"
        })])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [(item.isGroup) ? _c('td', [(item.groupEdit) ? _c('div', [_c('v-btn', {
          attrs: {
            "color": "success",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.updateXeroContact(item)
            }
          }
        }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "secondary",
            "small": ""
          },
          on: {
            "click": function($event) {
              item.groupEdit = false
            }
          }
        }, [_vm._v("\n                Cancel\n              ")])], 1) : _c('div', [(_vm.buttonShow('edit')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.openGroupEdit(item, true)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "xmall": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('delete')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "error"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteClientGroup(item.id, item.name)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("delete")])], 1) : _vm._e()], 1)]) : _c('td', [(_vm.buttonShow('delete')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "error"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteClient(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("delete")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('edit')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.getClientDataToEdit(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "xmall": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('view')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.getClientDataToView(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("remove_red_eye")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('updateUser')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.getClientUserDataToUpdate(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("perm_identity")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "no-results",
      fn: function() {
        return [_c('v-alert', {
          attrs: {
            "color": "error",
            "icon": "warning"
          }
        }, [_vm._v("\n            Your search for \"" + _vm._s(_vm.filter) + "\" found no results.\n          ")])]
      },
      proxy: true
    }, {
      key: "expanded-item",
      fn: function(ref) {
        var headers = ref.headers;
        var item = ref.item;

        return [(item.clients) ? _c('td', {
          staticStyle: {
            "border": "none",
            "padding": "20px"
          },
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-data-table', {
          staticClass: "client-nested-table client-group-table elevation-1",
          attrs: {
            "headers": _vm.fields,
            "items": item.clients,
            "show-expand": "",
            "expanded": _vm.expanded,
            "show-select": "",
            "single-select": false
          },
          on: {
            "update:expanded": function($event) {
              _vm.expanded = $event
            },
            "toggle-select-all": _vm.selectAllClients
          },
          scopedSlots: _vm._u([{
            key: "item.data-table-expand",
            fn: function(ref) {
              var item = ref.item;
              var expand = ref.expand;
              var isExpanded = ref.isExpanded;

              return [_c('span', [(isExpanded) ? _c('v-icon', {
                on: {
                  "click": function($event) {
                    return expand(false)
                  }
                }
              }, [_vm._v("mdi-chevron-up")]) : _c('v-icon', {
                on: {
                  "click": function($event) {
                    return expand(true)
                  }
                }
              }, [_vm._v("mdi-chevron-down")])], 1)]
            }
          }, {
            key: "item.data-table-select",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-checkbox', {
                attrs: {
                  "label": "",
                  "value": item,
                  "color": "grey darken-2"
                },
                model: {
                  value: (_vm.selectedClients),
                  callback: function($$v) {
                    _vm.selectedClients = $$v
                  },
                  expression: "selectedClients"
                }
              })]
            }
          }, {
            key: "item.IO",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', [_c('td', {
                staticClass: "text-center"
              }, [_vm._v(_vm._s(item.IO))])])]
            }
          }, {
            key: "item.dealCode",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', [_c('td', {
                staticClass: "text-center"
              }, [_vm._v(_vm._s(item.dealCode))])])]
            }
          }, {
            key: "item.budget",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', [(item.budget) ? _c('td', {
                staticClass: "text-center"
              }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.budget)))]) : _c('td', {
                staticClass: "text-center"
              })])]
            }
          }, {
            key: "item.action",
            fn: function(ref) {
              var item = ref.item;

              return [_c('td', [(_vm.buttonShow('delete')) ? _c('v-btn', {
                staticClass: "ims-action",
                attrs: {
                  "color": "error"
                },
                on: {
                  "click": function($event) {
                    $event.stopPropagation();
                    return _vm.deleteClient(item.id)
                  }
                }
              }, [_c('v-icon', {
                attrs: {
                  "color": "white",
                  "small": ""
                }
              }, [_vm._v("delete")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('edit')) ? _c('v-btn', {
                staticClass: "ims-action",
                attrs: {
                  "color": "secondary"
                },
                on: {
                  "click": function($event) {
                    return _vm.getClientDataToEdit(item.id)
                  }
                }
              }, [_c('v-icon', {
                attrs: {
                  "xmall": ""
                }
              }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('view')) ? _c('v-btn', {
                staticClass: "ims-action",
                attrs: {
                  "color": "secondary"
                },
                on: {
                  "click": function($event) {
                    return _vm.getClientDataToView(item.id)
                  }
                }
              }, [_c('v-icon', {
                attrs: {
                  "small": ""
                }
              }, [_vm._v("remove_red_eye")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('updateUser')) ? _c('v-btn', {
                staticClass: "ims-action",
                attrs: {
                  "color": "secondary"
                },
                on: {
                  "click": function($event) {
                    return _vm.getClientUserDataToUpdate(item)
                  }
                }
              }, [_c('v-icon', {
                attrs: {
                  "small": ""
                }
              }, [_vm._v("perm_identity")])], 1) : _vm._e()], 1)]
            }
          }, {
            key: "expanded-item",
            fn: function(ref) {
              var headers = ref.headers;
              var item = ref.item;

              return [_c('td', {
                staticClass: "client-expanded-cell",
                attrs: {
                  "colspan": headers.length
                }
              }, [_c('v-data-table', {
                staticClass: "client-nested-table client-deal-table elevation-1",
                attrs: {
                  "striped": "",
                  "bordered": "",
                  "hover": "",
                  "responsive": "",
                  "headers": _vm.dealFields,
                  "items": item.deals,
                  "show-expand": "",
                  "expanded": _vm.expanded,
                  "item-key": "index",
                  "single-select": false
                },
                on: {
                  "update:expanded": function($event) {
                    _vm.expanded = $event
                  }
                },
                scopedSlots: _vm._u([{
                  key: "item.data-table-expand",
                  fn: function(ref) {
                    var item = ref.item;
                    var expand = ref.expand;
                    var isExpanded = ref.isExpanded;

                    return [_c('span', [(isExpanded) ? _c('v-icon', {
                      on: {
                        "click": function($event) {
                          return expand(false)
                        }
                      }
                    }, [_vm._v("mdi-chevron-up")]) : _c('v-icon', {
                      on: {
                        "click": function($event) {
                          return expand(true)
                        }
                      }
                    }, [_vm._v("mdi-chevron-down")])], 1)]
                  }
                }, {
                  key: "item.budget",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('td', {
                      staticClass: "text-xs-left"
                    }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.budget)))])]
                  }
                }, {
                  key: "item.IO",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('td', {
                      staticClass: "text-xs-left"
                    }, [_c('div', [_vm._v(_vm._s(item.IO))]), _vm._v(" "), (item.linkedIOs) ? _c('span', [_vm._v(_vm._s(_vm.showLinkedIO(item.linkedIOs)))]) : _vm._e()])]
                  }
                }, {
                  key: "item.action",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('v-menu', {
                      attrs: {
                        "offset-y": ""
                      },
                      scopedSlots: _vm._u([{
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on;
                          var attrs = ref.attrs;

                          return [_c('v-btn', _vm._g(_vm._b({
                            attrs: {
                              "color": "secondary",
                              "small": ""
                            }
                          }, 'v-btn', attrs, false), on), [_vm._v("\n                            Allocate\n                          ")])]
                        }
                      }], null, true)
                    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
                      on: {
                        "click": function($event) {
                          return _vm.addAllocate(item, 'all')
                        }
                      }
                    }, [_c('v-list-item-title', [_vm._v("All (100%)")])], 1), _vm._v(" "), _c('v-list-item', {
                      attrs: {
                        "link": ""
                      },
                      on: {
                        "click": function($event) {
                          return _vm.addAllocate(item, 'custom')
                        }
                      }
                    }, [_c('v-list-item-title', [_vm._v("Custom")])], 1)], 1)], 1)]
                  }
                }, {
                  key: "expanded-item",
                  fn: function(ref) {
                    var headers = ref.headers;
                    var item = ref.item;

                    return [(item.campaigns) ? _c('td', {
                      staticClass: "client-expanded-cell",
                      attrs: {
                        "colspan": headers.length
                      }
                    }, [_c('v-hover', {
                      scopedSlots: _vm._u([{
                        key: "default",
                        fn: function(ref) {
                          var hover = ref.hover;

                          return [_c('v-card', {
                            class: {
                              'mx-auto mb-2 text-center on-hover': hover,
                              'mx-auto mb-2 text-center': !hover
                            },
                            staticStyle: {
                              "width": "300px"
                            },
                            attrs: {
                              "color": "#363636",
                              "dark": "",
                              "elevation": hover ? 12 : 2
                            }
                          }, [_c('v-card-subtitle', [_c('p', {
                            staticClass: "pa-0 ma-0 custom-font"
                          }, [_vm._v("Used Budget: $" + _vm._s(_vm._f("thousandSeprator")(_vm.getUsedBudgets(item.campaigns))))]), _vm._v(" "), _c('p', {
                            staticClass: "pa-0 ma-0 custom-font"
                          }, [_vm._v("Remain Budgets: $" + _vm._s(_vm._f("thousandSeprator")(_vm.getRemainBudgets(item.campaigns))))])])], 1)]
                        }
                      }], null, true)
                    }), _vm._v(" "), _c('v-data-table', {
                      key: _vm.dataTableKey,
                      staticClass: "client-nested-table campaign-data-table client-table-small elevation-1",
                      attrs: {
                        "striped": "",
                        "bordered": "",
                        "hover": "",
                        "responsive": "",
                        "headers": _vm.campaignFields,
                        "items": item.campaigns,
                        "item-key": "campaignIndex"
                      },
                      scopedSlots: _vm._u([{
                        key: "item.name",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                            staticClass: "input-field mt-3",
                            attrs: {
                              "dense": "",
                              "outlined": "",
                              "placeholder": "Campaign Name"
                            },
                            model: {
                              value: (item.name),
                              callback: function($$v) {
                                _vm.$set(item, "name", $$v)
                              },
                              expression: "item.name"
                            }
                          }, _vm.on))], 1) : _c('div', {
                            staticClass: "item-edit"
                          }, [_c('td', {
                            staticClass: "text-center"
                          }, [_vm._v("\n                              " + _vm._s(item.name) + "\n                               "), (item.allocatePercent) ? _c('span', [_vm._v("( " + _vm._s(item.allocatePercent) + "% )")]) : _vm._e()])])]
                        }
                      }, {
                        key: "item.partCode",
                        fn: function(ref) {
                          var item = ref.item;

                          return [_c('td', {
                            staticClass: "text-center"
                          }, [_vm._v(_vm._s(item.partCode))])]
                        }
                      }, {
                        key: "item.outreach",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                            staticClass: "input-field mt-3",
                            attrs: {
                              "type": "number",
                              "dense": "",
                              "outlined": "",
                              "placeholder": "Outreach"
                            },
                            model: {
                              value: (item.outreach),
                              callback: function($$v) {
                                _vm.$set(item, "outreach", $$v)
                              },
                              expression: "item.outreach"
                            }
                          }, _vm.on))], 1) : _c('div', {
                            staticClass: "item-edit"
                          }, [_c('td', {
                            staticClass: "text-xs-left"
                          }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.outreach)))])])]
                        }
                      }, {
                        key: "item.period",
                        fn: function(ref) {
                          var item = ref.item;

                          return [_c('td', {
                            staticClass: "text-center"
                          }, [_vm._v(_vm._s(item.period))])]
                        }
                      }, {
                        key: "item.recognizedRevenue",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.recognizedRevenue !== '') ? _c('td', {
                            staticClass: "text-center"
                          }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.formatDecimal(item.recognizedRevenue))))]) : _c('td', {
                            staticClass: "text-center"
                          })]
                        }
                      }, {
                        key: "item.unRecognizedRevenue",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.unRecognizedRevenue !== '') ? _c('td', {
                            staticClass: "text-center"
                          }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.formatDecimal(item.unRecognizedRevenue))))]) : _c('td', {
                            staticClass: "text-center"
                          })]
                        }
                      }, {
                        key: "item.cogs",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.cogs !== '') ? _c('td', {
                            staticClass: "text-center"
                          }, [_vm._v("$" + _vm._s(item.cogs) + " (" + _vm._s(item.cogsPercentage) + "%)")]) : _c('td', {
                            staticClass: "text-center"
                          })]
                        }
                      }, {
                        key: "item.budget",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                            staticClass: "input-field mt-3",
                            attrs: {
                              "type": "number",
                              "dense": "",
                              "outlined": "",
                              "placeholder": "Budget"
                            },
                            model: {
                              value: (item.budget),
                              callback: function($$v) {
                                _vm.$set(item, "budget", $$v)
                              },
                              expression: "item.budget"
                            }
                          }, _vm.on))], 1) : _c('div', {
                            staticClass: "item-edit"
                          }, [_c('td', {
                            staticClass: "text-xs-left"
                          }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.budget)))])])]
                        }
                      }, {
                        key: "item.content",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                            staticClass: "input-field mt-3 mb-1",
                            attrs: {
                              "type": "number",
                              "hide-details": "",
                              "dense": "",
                              "outlined": "",
                              "placeholder": "min"
                            },
                            model: {
                              value: (item.min_content),
                              callback: function($$v) {
                                _vm.$set(item, "min_content", $$v)
                              },
                              expression: "item.min_content"
                            }
                          }, _vm.on)), _vm._v(" "), _c('p', {
                            staticClass: "text-center ma-0"
                          }, [_vm._v("to")]), _vm._v(" "), _c('v-text-field', _vm._g({
                            staticClass: "input-field mb-1",
                            attrs: {
                              "type": "number",
                              "dense": "",
                              "outlined": "",
                              "placeholder": "max"
                            },
                            model: {
                              value: (item.max_content),
                              callback: function($$v) {
                                _vm.$set(item, "max_content", $$v)
                              },
                              expression: "item.max_content"
                            }
                          }, _vm.on))], 1) : _c('div', {
                            staticClass: "item-edit"
                          }, [_c('td', {
                            staticClass: "text-xs-left"
                          }, [_vm._v(_vm._s(item.min_content) + " - " + _vm._s(item.max_content))])])]
                        }
                      }, {
                        key: "item.engagement",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                            staticClass: "input-field mt-3",
                            attrs: {
                              "type": "number",
                              "dense": "",
                              "outlined": "",
                              "placeholder": "Engagement"
                            },
                            model: {
                              value: (item.engagement),
                              callback: function($$v) {
                                _vm.$set(item, "engagement", $$v)
                              },
                              expression: "item.engagement"
                            }
                          }, _vm.on))], 1) : _c('div', {
                            staticClass: "item-edit"
                          }, [_c('td', {
                            staticClass: "text-xs-left"
                          }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.engagement)))])])]
                        }
                      }, {
                        key: "item.kpi_onboarded",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                            staticClass: "input-field mt-3",
                            attrs: {
                              "type": "number",
                              "dense": "",
                              "outlined": "",
                              "placeholder": "KPI Onboarded"
                            },
                            model: {
                              value: (item.kpi_onboarded),
                              callback: function($$v) {
                                _vm.$set(item, "kpi_onboarded", $$v)
                              },
                              expression: "item.kpi_onboarded"
                            }
                          }, _vm.on))], 1) : _c('div', {
                            staticClass: "item-edit"
                          }, [_c('td', {
                            staticClass: "text-xs-left"
                          }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.kpi_onboarded)))])])]
                        }
                      }, {
                        key: "item.campaignType",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.edit) ? _c('div', [_c('v-select', {
                            staticClass: "input-field",
                            attrs: {
                              "items": _vm.campaignTypeDisplay,
                              "label": "Product Type",
                              "dense": "",
                              "outlined": ""
                            },
                            model: {
                              value: (item.campaignType),
                              callback: function($$v) {
                                _vm.$set(item, "campaignType", $$v)
                              },
                              expression: "item.campaignType"
                            }
                          })], 1) : _c('div', {
                            staticClass: "item-edit"
                          }, [_c('td', {
                            staticClass: "text-xs-left"
                          }, [_vm._v(_vm._s(item.campaignType))])])]
                        }
                      }, {
                        key: "item.country",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.edit) ? _c('div', [_c('v-combobox', {
                            attrs: {
                              "search-input": _vm.newCountry,
                              "items": _vm.countries,
                              "item-text": "name",
                              "item-value": "code",
                              "hide-selected": "",
                              "chips": "",
                              "label": "Country",
                              "multiple": "",
                              "dense": "",
                              "outlined": ""
                            },
                            on: {
                              "update:searchInput": function($event) {
                                _vm.newCountry = $event
                              },
                              "update:search-input": function($event) {
                                _vm.newCountry = $event
                              }
                            },
                            scopedSlots: _vm._u([{
                              key: "selection",
                              fn: function(ref) {
                                var attrs = ref.attrs;
                                var item = ref.item;
                                var parent = ref.parent;
                                var selected = ref.selected;

                                return [(item === Object(item)) ? _c('v-chip', _vm._b({
                                  attrs: {
                                    "input-value": selected,
                                    "label": "",
                                    "small": ""
                                  }
                                }, 'v-chip', attrs, false), [_c('span', {
                                  staticClass: "pr-2"
                                }, [_vm._v("\n                                      " + _vm._s(item.name) + "\n                                    ")]), _vm._v(" "), _c('v-icon', {
                                  attrs: {
                                    "small": ""
                                  },
                                  on: {
                                    "click": function($event) {
                                      return parent.selectItem(item)
                                    }
                                  }
                                }, [_vm._v("\n                                      $delete\n                                    ")])], 1) : _c('v-chip', _vm._b({
                                  attrs: {
                                    "input-value": selected,
                                    "label": "",
                                    "small": ""
                                  }
                                }, 'v-chip', attrs, false), [_c('span', {
                                  staticClass: "pr-2"
                                }, [_vm._v("\n                                      " + _vm._s(item) + "\n                                    ")]), _vm._v(" "), _c('v-icon', {
                                  attrs: {
                                    "small": ""
                                  },
                                  on: {
                                    "click": function($event) {
                                      return parent.selectItem(item)
                                    }
                                  }
                                }, [_vm._v("\n                                      $delete\n                                    ")])], 1)]
                              }
                            }], null, true),
                            model: {
                              value: (item.country),
                              callback: function($$v) {
                                _vm.$set(item, "country", $$v)
                              },
                              expression: "item.country"
                            }
                          })], 1) : _c('div', {
                            staticClass: "item-edit"
                          }, [_c('td', {
                            staticClass: "text-xs-left"
                          }, _vm._l((item.country), function(item, index) {
                            return _c('v-chip', {
                              key: index,
                              staticClass: "ma-1",
                              attrs: {
                                "small": ""
                              }
                            }, [_vm._v("\n                                  " + _vm._s(item.name) + "\n                                ")])
                          }), 1)])]
                        }
                      }, {
                        key: "item.vertical",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.edit) ? _c('div', [_c('v-combobox', {
                            attrs: {
                              "items": _vm.campaignVerticals,
                              "item-text": "name",
                              "item-value": "name",
                              "hide-selected": "",
                              "dense": "",
                              "outlined": "",
                              "label": "Campaign Vertical",
                              "multiple": ""
                            },
                            scopedSlots: _vm._u([{
                              key: "selection",
                              fn: function(ref) {
                                var attrs = ref.attrs;
                                var item = ref.item;
                                var parent = ref.parent;
                                var selected = ref.selected;

                                return [(item === Object(item)) ? _c('v-chip', _vm._b({
                                  attrs: {
                                    "input-value": selected,
                                    "label": "",
                                    "small": ""
                                  }
                                }, 'v-chip', attrs, false), [_c('span', {
                                  staticClass: "pr-2"
                                }, [_vm._v("\n                                      " + _vm._s(item.name) + "\n                                    ")]), _vm._v(" "), _c('v-icon', {
                                  attrs: {
                                    "small": ""
                                  },
                                  on: {
                                    "click": function($event) {
                                      return parent.selectItem(item)
                                    }
                                  }
                                }, [_vm._v("\n                                      $delete\n                                    ")])], 1) : _vm._e()]
                              }
                            }], null, true),
                            model: {
                              value: (item.vertical),
                              callback: function($$v) {
                                _vm.$set(item, "vertical", $$v)
                              },
                              expression: "item.vertical"
                            }
                          })], 1) : _c('div', {
                            staticClass: "item-edit"
                          }, [_c('td', {
                            staticClass: "text-xs-left"
                          }, _vm._l((item.vertical), function(item, index) {
                            return _c('v-chip', {
                              key: index,
                              staticClass: "ma-1",
                              attrs: {
                                "small": ""
                              }
                            }, [_vm._v("\n                                  " + _vm._s(item.name) + "\n                                ")])
                          }), 1)])]
                        }
                      }, {
                        key: "item.assignedTo",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.assignedTo) ? _c('div', _vm._l((item.assignedTo), function(item, index) {
                            return _c('v-chip', {
                              key: index,
                              staticClass: "ma-2",
                              attrs: {
                                "value": item,
                                "filter": "",
                                "small": ""
                              }
                            }, [_c('v-avatar', {
                              staticStyle: {
                                "margin-right": "5px"
                              }
                            }, [_c('v-icon', {
                              attrs: {
                                "small": ""
                              }
                            }, [_vm._v("account_circle")])], 1), _vm._v("\n                                " + _vm._s(item.firstName + ' ' + item.lastName) + "\n                              ")], 1)
                          }), 1) : _vm._e()]
                        }
                      }, {
                        key: "item.assignedToAM",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.assignedToAM) ? _c('div', _vm._l((item.assignedToAM), function(item, index) {
                            return _c('v-chip', {
                              key: index,
                              staticClass: "ma-2",
                              attrs: {
                                "value": item,
                                "filter": "",
                                "small": ""
                              }
                            }, [_c('v-avatar', {
                              staticStyle: {
                                "margin-right": "5px"
                              }
                            }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                                " + _vm._s(item.firstName + ' ' + item.lastName) + "\n                              ")], 1)
                          }), 1) : _vm._e()]
                        }
                      }, {
                        key: "item.action",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(!item.edit) ? _c('div', [(_vm.buttonShow('edit')) ? _c('v-btn', {
                            staticClass: "ims-action",
                            attrs: {
                              "small": "",
                              "color": "secondary"
                            },
                            on: {
                              "click": function($event) {
                                item.edit = true
                              }
                            }
                          }, [_c('v-icon', {
                            attrs: {
                              "xmall": ""
                            }
                          }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('delete')) ? _c('v-btn', {
                            staticClass: "ims-action",
                            attrs: {
                              "small": "",
                              "color": "error"
                            },
                            on: {
                              "click": function($event) {
                                return _vm.deleteCampaign(item)
                              }
                            }
                          }, [_c('v-icon', {
                            attrs: {
                              "color": "white",
                              "small": ""
                            }
                          }, [_vm._v("delete")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.edit) ? _c('div', [_c('v-btn', {
                            staticClass: "mb-2",
                            attrs: {
                              "color": "success",
                              "small": ""
                            },
                            on: {
                              "click": function($event) {
                                return _vm.saveCampaign(item)
                              }
                            }
                          }, [_vm._v("Save")]), _vm._v(" "), (item.id === 0) ? _c('v-btn', {
                            attrs: {
                              "color": "secondary",
                              "small": ""
                            },
                            on: {
                              "click": function($event) {
                                return _vm.cancelCampaignRow(item)
                              }
                            }
                          }, [_vm._v("\n                                Cancel\n                              ")]) : _c('v-btn', {
                            attrs: {
                              "color": "secondary",
                              "small": ""
                            },
                            on: {
                              "click": function($event) {
                                item.edit = false
                              }
                            }
                          }, [_vm._v("\n                                Cancel\n                              ")])], 1) : _vm._e()]
                        }
                      }], null, true)
                    })], 1) : _vm._e()]
                  }
                }], null, true)
              })], 1)]
            }
          }], null, true),
          model: {
            value: (_vm.selectedClients),
            callback: function($$v) {
              _vm.selectedClients = $$v
            },
            expression: "selectedClients"
          }
        })], 1) : _c('td', {
          staticClass: "client-expanded-cell",
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-data-table', {
          staticClass: "client-nested-table client-deal-table elevation-1",
          attrs: {
            "striped": "",
            "bordered": "",
            "hover": "",
            "responsive": "",
            "headers": _vm.dealFields,
            "items": item.deals,
            "show-expand": "",
            "expanded": _vm.expanded,
            "item-key": "index",
            "single-select": false
          },
          on: {
            "update:expanded": function($event) {
              _vm.expanded = $event
            }
          },
          scopedSlots: _vm._u([{
            key: "item.data-table-expand",
            fn: function(ref) {
              var item = ref.item;
              var expand = ref.expand;
              var isExpanded = ref.isExpanded;

              return [_c('span', [(isExpanded) ? _c('v-icon', {
                on: {
                  "click": function($event) {
                    return expand(false)
                  }
                }
              }, [_vm._v("mdi-chevron-up")]) : _c('v-icon', {
                on: {
                  "click": function($event) {
                    return expand(true)
                  }
                }
              }, [_vm._v("mdi-chevron-down")])], 1)]
            }
          }, {
            key: "item.linkedIOs",
            fn: function(ref) {
              var item = ref.item;

              return [_c('td', {
                staticClass: "text-xs-left"
              }, [(item.linkedIOs) ? _c('span', [_vm._v(_vm._s(_vm.showLinkedIO(item.linkedIOs)))]) : _vm._e()])]
            }
          }, {
            key: "item.budget",
            fn: function(ref) {
              var item = ref.item;

              return [_c('td', {
                staticClass: "text-xs-left"
              }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.budget)))])]
            }
          }, {
            key: "item.action",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-menu', {
                attrs: {
                  "offset-y": ""
                },
                scopedSlots: _vm._u([{
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on;
                    var attrs = ref.attrs;

                    return [_c('v-btn', _vm._g(_vm._b({
                      attrs: {
                        "color": "secondary",
                        "small": ""
                      }
                    }, 'v-btn', attrs, false), on), [_vm._v("\n                      Allocate\n                    ")])]
                  }
                }], null, true)
              }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
                attrs: {
                  "link": ""
                },
                on: {
                  "click": function($event) {
                    return _vm.addAllocate(item, 'custom')
                  }
                }
              }, [_c('v-list-item-title', [_vm._v("New")])], 1), _vm._v(" "), _c('v-list-item', {
                on: {
                  "click": function($event) {
                    return _vm.addAllocate(item, 'all')
                  }
                }
              }, [_c('v-list-item-title', [_vm._v("All")])], 1)], 1)], 1)]
            }
          }, {
            key: "expanded-item",
            fn: function(ref) {
              var headers = ref.headers;
              var item = ref.item;

              return [(item.campaigns) ? _c('td', {
                staticClass: "client-expanded-cell",
                attrs: {
                  "colspan": headers.length
                }
              }, [_c('v-hover', {
                scopedSlots: _vm._u([{
                  key: "default",
                  fn: function(ref) {
                    var hover = ref.hover;

                    return [_c('v-card', {
                      class: {
                        'mx-auto mb-2 text-center on-hover': hover,
                        'mx-auto mb-2 text-center': !hover
                      },
                      staticStyle: {
                        "width": "300px"
                      },
                      attrs: {
                        "color": "#363636",
                        "dark": "",
                        "elevation": hover ? 12 : 2
                      }
                    }, [_c('v-card-subtitle', [_c('p', {
                      staticClass: "pa-0 ma-0 custom-font"
                    }, [_vm._v("Used Budget: $" + _vm._s(_vm._f("thousandSeprator")(_vm.getUsedBudgets(item.campaigns))))]), _vm._v(" "), _c('p', {
                      staticClass: "pa-0 ma-0 custom-font"
                    }, [_vm._v("Remain Budgets: $" + _vm._s(_vm._f("thousandSeprator")(_vm.getRemainBudgets(item.campaigns))))])])], 1)]
                  }
                }], null, true)
              }), _vm._v(" "), _c('v-data-table', {
                key: _vm.dataTableKey,
                staticClass: "client-nested-table campaign-data-table client-table-small elevation-1",
                attrs: {
                  "striped": "",
                  "bordered": "",
                  "hover": "",
                  "responsive": "",
                  "headers": _vm.campaignFields,
                  "items": item.campaigns,
                  "item-key": "campaignIndex"
                },
                scopedSlots: _vm._u([{
                  key: "item.name",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                      staticClass: "input-field mt-3",
                      attrs: {
                        "dense": "",
                        "outlined": "",
                        "placeholder": "Campaign Name"
                      },
                      model: {
                        value: (item.name),
                        callback: function($$v) {
                          _vm.$set(item, "name", $$v)
                        },
                        expression: "item.name"
                      }
                    }, _vm.on))], 1) : _c('div', {
                      staticClass: "item-edit"
                    }, [_c('td', {
                      staticClass: "text-center"
                    }, [_vm._v(_vm._s(item.name))])])]
                  }
                }, {
                  key: "item.partCode",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('td', {
                      staticClass: "text-center"
                    }, [_vm._v(_vm._s(item.partCode))])]
                  }
                }, {
                  key: "item.outreach",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                      staticClass: "input-field mt-3",
                      attrs: {
                        "type": "number",
                        "dense": "",
                        "outlined": "",
                        "placeholder": "Outreach"
                      },
                      model: {
                        value: (item.outreach),
                        callback: function($$v) {
                          _vm.$set(item, "outreach", $$v)
                        },
                        expression: "item.outreach"
                      }
                    }, _vm.on))], 1) : _c('div', {
                      staticClass: "item-edit"
                    }, [_c('td', {
                      staticClass: "text-xs-left"
                    }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.outreach)))])])]
                  }
                }, {
                  key: "item.period",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('td', {
                      staticClass: "text-center"
                    }, [_vm._v(_vm._s(item.period))])]
                  }
                }, {
                  key: "item.recognizedRevenue",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.recognizedRevenue !== '') ? _c('td', {
                      staticClass: "text-center"
                    }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.formatDecimal(item.recognizedRevenue))))]) : _c('td', {
                      staticClass: "text-center"
                    })]
                  }
                }, {
                  key: "item.unRecognizedRevenue",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.unRecognizedRevenue !== '') ? _c('td', {
                      staticClass: "text-center"
                    }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.formatDecimal(item.unRecognizedRevenue))))]) : _c('td', {
                      staticClass: "text-center"
                    })]
                  }
                }, {
                  key: "item.cogs",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.cogs !== '') ? _c('td', {
                      staticClass: "text-center"
                    }, [_vm._v("$" + _vm._s(item.cogs) + " (" + _vm._s(item.cogsPercentage) + "%)")]) : _c('td', {
                      staticClass: "text-center"
                    })]
                  }
                }, {
                  key: "item.budget",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                      staticClass: "input-field mt-3",
                      attrs: {
                        "type": "number",
                        "dense": "",
                        "outlined": "",
                        "placeholder": "Budget"
                      },
                      model: {
                        value: (item.budget),
                        callback: function($$v) {
                          _vm.$set(item, "budget", $$v)
                        },
                        expression: "item.budget"
                      }
                    }, _vm.on))], 1) : _c('div', {
                      staticClass: "item-edit"
                    }, [_c('td', {
                      staticClass: "text-xs-left"
                    }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.budget)))])])]
                  }
                }, {
                  key: "item.content",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                      staticClass: "input-field mt-3 mb-1",
                      attrs: {
                        "type": "number",
                        "hide-details": "",
                        "dense": "",
                        "outlined": "",
                        "placeholder": "min"
                      },
                      model: {
                        value: (item.min_content),
                        callback: function($$v) {
                          _vm.$set(item, "min_content", $$v)
                        },
                        expression: "item.min_content"
                      }
                    }, _vm.on)), _vm._v(" "), _c('p', {
                      staticClass: "text-center ma-0"
                    }, [_vm._v("to")]), _vm._v(" "), _c('v-text-field', _vm._g({
                      staticClass: "input-field mb-1",
                      attrs: {
                        "type": "number",
                        "dense": "",
                        "outlined": "",
                        "placeholder": "max"
                      },
                      model: {
                        value: (item.max_content),
                        callback: function($$v) {
                          _vm.$set(item, "max_content", $$v)
                        },
                        expression: "item.max_content"
                      }
                    }, _vm.on))], 1) : _c('div', {
                      staticClass: "item-edit"
                    }, [_c('td', {
                      staticClass: "text-xs-left"
                    }, [_vm._v(_vm._s(item.min_content) + " - " + _vm._s(item.max_content))])])]
                  }
                }, {
                  key: "item.engagement",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                      staticClass: "input-field mt-3",
                      attrs: {
                        "type": "number",
                        "dense": "",
                        "outlined": "",
                        "placeholder": "Engagement"
                      },
                      model: {
                        value: (item.engagement),
                        callback: function($$v) {
                          _vm.$set(item, "engagement", $$v)
                        },
                        expression: "item.engagement"
                      }
                    }, _vm.on))], 1) : _c('div', {
                      staticClass: "item-edit"
                    }, [_c('td', {
                      staticClass: "text-xs-left"
                    }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.engagement)))])])]
                  }
                }, {
                  key: "item.kpi_onboarded",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                      staticClass: "input-field mt-3",
                      attrs: {
                        "type": "number",
                        "dense": "",
                        "outlined": "",
                        "placeholder": "KPI Onboarded"
                      },
                      model: {
                        value: (item.kpi_onboarded),
                        callback: function($$v) {
                          _vm.$set(item, "kpi_onboarded", $$v)
                        },
                        expression: "item.kpi_onboarded"
                      }
                    }, _vm.on))], 1) : _c('div', {
                      staticClass: "item-edit"
                    }, [_c('td', {
                      staticClass: "text-xs-left"
                    }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.kpi_onboarded)))])])]
                  }
                }, {
                  key: "item.campaignType",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.edit) ? _c('div', [_c('v-select', {
                      staticClass: "input-field",
                      attrs: {
                        "items": _vm.campaignTypeDisplay,
                        "label": "Product Type",
                        "dense": "",
                        "outlined": ""
                      },
                      model: {
                        value: (item.campaignType),
                        callback: function($$v) {
                          _vm.$set(item, "campaignType", $$v)
                        },
                        expression: "item.campaignType"
                      }
                    })], 1) : _c('div', {
                      staticClass: "item-edit"
                    }, [_c('td', {
                      staticClass: "text-xs-left"
                    }, [_vm._v(_vm._s(item.campaignType))])])]
                  }
                }, {
                  key: "item.country",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.edit) ? _c('div', [_c('v-combobox', {
                      attrs: {
                        "search-input": _vm.newCountry,
                        "items": _vm.countries,
                        "item-text": "name",
                        "item-value": "code",
                        "hide-selected": "",
                        "chips": "",
                        "label": "Country",
                        "multiple": "",
                        "dense": "",
                        "outlined": ""
                      },
                      on: {
                        "update:searchInput": function($event) {
                          _vm.newCountry = $event
                        },
                        "update:search-input": function($event) {
                          _vm.newCountry = $event
                        }
                      },
                      scopedSlots: _vm._u([{
                        key: "selection",
                        fn: function(ref) {
                          var attrs = ref.attrs;
                          var item = ref.item;
                          var parent = ref.parent;
                          var selected = ref.selected;

                          return [(item === Object(item)) ? _c('v-chip', _vm._b({
                            attrs: {
                              "input-value": selected,
                              "label": "",
                              "small": ""
                            }
                          }, 'v-chip', attrs, false), [_c('span', {
                            staticClass: "pr-2"
                          }, [_vm._v("\n                                " + _vm._s(item.name) + "\n                              ")]), _vm._v(" "), _c('v-icon', {
                            attrs: {
                              "small": ""
                            },
                            on: {
                              "click": function($event) {
                                return parent.selectItem(item)
                              }
                            }
                          }, [_vm._v("\n                                $delete\n                              ")])], 1) : _c('v-chip', _vm._b({
                            attrs: {
                              "input-value": selected,
                              "label": "",
                              "small": ""
                            }
                          }, 'v-chip', attrs, false), [_c('span', {
                            staticClass: "pr-2"
                          }, [_vm._v("\n                                " + _vm._s(item) + "\n                              ")]), _vm._v(" "), _c('v-icon', {
                            attrs: {
                              "small": ""
                            },
                            on: {
                              "click": function($event) {
                                return parent.selectItem(item)
                              }
                            }
                          }, [_vm._v("\n                                $delete\n                              ")])], 1)]
                        }
                      }], null, true),
                      model: {
                        value: (item.country),
                        callback: function($$v) {
                          _vm.$set(item, "country", $$v)
                        },
                        expression: "item.country"
                      }
                    })], 1) : _c('div', {
                      staticClass: "item-edit"
                    }, [_c('td', {
                      staticClass: "text-xs-left"
                    }, _vm._l((item.country), function(item, index) {
                      return _c('v-chip', {
                        key: index,
                        staticClass: "ma-1",
                        attrs: {
                          "small": ""
                        }
                      }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                          ")])
                    }), 1)])]
                  }
                }, {
                  key: "item.vertical",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.edit) ? _c('div', [_c('v-combobox', {
                      attrs: {
                        "items": _vm.campaignVerticals,
                        "item-text": "name",
                        "item-value": "name",
                        "hide-selected": "",
                        "dense": "",
                        "outlined": "",
                        "label": "Campaign Vertical",
                        "multiple": ""
                      },
                      scopedSlots: _vm._u([{
                        key: "selection",
                        fn: function(ref) {
                          var attrs = ref.attrs;
                          var item = ref.item;
                          var parent = ref.parent;
                          var selected = ref.selected;

                          return [(item === Object(item)) ? _c('v-chip', _vm._b({
                            attrs: {
                              "input-value": selected,
                              "label": "",
                              "small": ""
                            }
                          }, 'v-chip', attrs, false), [_c('span', {
                            staticClass: "pr-2"
                          }, [_vm._v("\n                                " + _vm._s(item.name) + "\n                              ")]), _vm._v(" "), _c('v-icon', {
                            attrs: {
                              "small": ""
                            },
                            on: {
                              "click": function($event) {
                                return parent.selectItem(item)
                              }
                            }
                          }, [_vm._v("\n                                $delete\n                              ")])], 1) : _vm._e()]
                        }
                      }], null, true),
                      model: {
                        value: (item.vertical),
                        callback: function($$v) {
                          _vm.$set(item, "vertical", $$v)
                        },
                        expression: "item.vertical"
                      }
                    })], 1) : _c('div', {
                      staticClass: "item-edit"
                    }, [_c('td', {
                      staticClass: "text-xs-left"
                    }, _vm._l((item.vertical), function(item, index) {
                      return _c('v-chip', {
                        key: index,
                        staticClass: "ma-1",
                        attrs: {
                          "small": ""
                        }
                      }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                          ")])
                    }), 1)])]
                  }
                }, {
                  key: "item.assignedTo",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.assignedTo) ? _c('div', _vm._l((item.assignedTo), function(item, index) {
                      return _c('v-chip', {
                        key: index,
                        staticClass: "ma-2",
                        attrs: {
                          "value": item,
                          "filter": ""
                        }
                      }, [_c('v-avatar', {
                        staticStyle: {
                          "margin-right": "5px"
                        }
                      }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                          " + _vm._s(item.firstName + ' ' + item.lastName) + "\n                        ")], 1)
                    }), 1) : _vm._e()]
                  }
                }, {
                  key: "item.assignedToAM",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.assignedToAM) ? _c('div', _vm._l((item.assignedToAM), function(item, index) {
                      return _c('v-chip', {
                        key: index,
                        staticClass: "ma-2",
                        attrs: {
                          "value": item,
                          "filter": ""
                        }
                      }, [_c('v-avatar', {
                        staticStyle: {
                          "margin-right": "5px"
                        }
                      }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                          " + _vm._s(item.firstName + ' ' + item.lastName) + "\n                        ")], 1)
                    }), 1) : _vm._e()]
                  }
                }, {
                  key: "item.action",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(!item.edit) ? _c('div', [(_vm.buttonShow('edit')) ? _c('v-btn', {
                      staticClass: "ims-action",
                      attrs: {
                        "small": "",
                        "color": "secondary"
                      },
                      on: {
                        "click": function($event) {
                          item.edit = true
                        }
                      }
                    }, [_c('v-icon', {
                      attrs: {
                        "xmall": ""
                      }
                    }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('delete')) ? _c('v-btn', {
                      staticClass: "ims-action",
                      attrs: {
                        "small": "",
                        "color": "error"
                      },
                      on: {
                        "click": function($event) {
                          return _vm.deleteCampaign(item)
                        }
                      }
                    }, [_c('v-icon', {
                      attrs: {
                        "color": "white",
                        "small": ""
                      }
                    }, [_vm._v("delete")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.edit) ? _c('div', [_c('v-btn', {
                      staticClass: "mb-2",
                      attrs: {
                        "color": "success",
                        "small": ""
                      },
                      on: {
                        "click": function($event) {
                          return _vm.saveCampaign(item)
                        }
                      }
                    }, [_vm._v("Save")]), _vm._v(" "), (item.id === 0) ? _c('v-btn', {
                      attrs: {
                        "color": "secondary",
                        "small": ""
                      },
                      on: {
                        "click": function($event) {
                          return _vm.cancelCampaignRow(item)
                        }
                      }
                    }, [_vm._v("\n                          Cancel\n                        ")]) : _c('v-btn', {
                      attrs: {
                        "color": "secondary",
                        "small": ""
                      },
                      on: {
                        "click": function($event) {
                          item.edit = false
                        }
                      }
                    }, [_vm._v("\n                          Cancel\n                        ")])], 1) : _vm._e()]
                  }
                }], null, true)
              })], 1) : _vm._e()]
            }
          }], null, true)
        })], 1)]
      }
    }], null, true),
    model: {
      value: (_vm.selectedClients),
      callback: function($$v) {
        _vm.selectedClients = $$v
      },
      expression: "selectedClients"
    }
  })], 1)], 1), _vm._v(" "), _c('create-client-modal', {
    on: {
      "createClient": _vm.createClient
    },
    model: {
      value: (_vm.createClientDialog),
      callback: function($$v) {
        _vm.createClientDialog = $$v
      },
      expression: "createClientDialog"
    }
  }), _vm._v(" "), _c('edit-client-modal', {
    attrs: {
      "clientData": _vm.editClientData,
      "viewMode": _vm.isViewMode
    },
    on: {
      "editClient": _vm.editClient
    },
    model: {
      value: (_vm.editClientDialog),
      callback: function($$v) {
        _vm.editClientDialog = $$v
      },
      expression: "editClientDialog"
    }
  }), _vm._v(" "), _c('update-client-user-modal', {
    attrs: {
      "clientLoginData": _vm.updateClientLoginData,
      "existingAccounts": _vm.existingAccounts
    },
    on: {
      "reRenderDataTable": _vm.reRenderDataTable
    },
    model: {
      value: (_vm.updateClientLoginModal),
      callback: function($$v) {
        _vm.updateClientLoginModal = $$v
      },
      expression: "updateClientLoginModal"
    }
  }), _vm._v(" "), _c('view-client-modal', {
    attrs: {
      "clientData": _vm.viewClientData
    },
    model: {
      value: (_vm.viewClientDialog),
      callback: function($$v) {
        _vm.viewClientDialog = $$v
      },
      expression: "viewClientDialog"
    }
  }), _vm._v(" "), _c('client-group-modal', {
    attrs: {
      "selectedClients": _vm.selectedClients
    },
    on: {
      "saved": _vm.savedClientGroup
    },
    model: {
      value: (_vm.clientGroupDialog),
      callback: function($$v) {
        _vm.clientGroupDialog = $$v
      },
      expression: "clientGroupDialog"
    }
  }), _vm._v(" "), _c('custom-amount-update-modal', {
    attrs: {
      "value": _vm.customAmountUpdateDialog,
      "dealData": _vm.viewDealData
    },
    on: {
      "addedAmount": _vm.allocateCampaign
    },
    model: {
      value: (_vm.customAmountUpdateDialog),
      callback: function($$v) {
        _vm.customAmountUpdateDialog = $$v
      },
      expression: "customAmountUpdateDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73d1105e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Client/index.vue
// module id = 2198
// module chunks = 0